module.exports = __webpack_public_path__ + "static/media/Impreza-GE-GH.1b5fd8bb.jpg";